<i18n src="@/i18n/template/components/NewUploader.json"></i18n>
<template>
  <div class="new-uploader">
    <div
      class="file-drop-area"
      :style="disabled && { background: '#909399' }"
      @dragover.prevent
      @drop.prevent="onDrop"
      @click="triggerFileInput"
    >
      <i class="el-icon-upload"></i>
      <p>
        {{ $t('DropFilesHere') }}
        <a href="#">
          {{ $t('ClickUpload') }}
        </a>
      </p>
      <input
        type="file"
        :accept="acceptValue"
        @change="onInputFileChange"
        :disabled="disabled"
        :multiple="multiple"
        ref="fileInput"
        style="display: none"
      />
    </div>
    <div class="file-name" v-if="filename">
      <span>{{ $t('File') }}: {{ filename }}</span>
      <!-- <el-button type="text" icon="el-icon-delete"></el-button> -->
    </div>
    <template v-if="filelist">
      <div
        class="file-name"
        v-for="(item, index) in filelist"
        :key="item.filename + index"
      >
        <span>{{ item.filename }}</span>
        <el-button
          type="text"
          icon="el-icon-delete"
          @click="onRemove(index)"
        ></el-button>
      </div>
    </template>
  </div>
</template>

<script>
import { XLSX_MAX_SIZE } from '@/constant'
export default {
  name: 'file-uploader',
  props: [
    'accept',
    'source',
    'filename',
    'filelist',
    'multiple',
    'disabled',
    'maxSize',
    'custId', // 附件上传需要传
    // 限制选择文件类型 video / image
    'fileType',
    // 当前选择的视频时长
    'videoDuration',
    // 限制视频时长 秒
    'videoMaxDuration',
    'videoMaxSize'
  ],
  computed: {
    acceptValue() {
      if (this.accept) {
        return this.accept
      }
      if (this.fileType === 'video') {
        return 'video/mp4,video/quicktime,video/x-msvideo,video/mpeg,video/x-ms-wmv,video/x-flv,video/mkv,video/rmvb'
      }
      if (this.fileType === 'image') {
        return 'image/jpeg,image/png,image/gif'
      }
      if (this.fileType === 'imageAndVideo') {
        return 'video/mp4,video/quicktime,video/x-msvideo,video/mpeg,video/x-ms-wmv,video/x-flv,video/mkv,video/rmvb,image/jpeg,image/png,image/gif'
      }
      return ''
    }
  },
  data() {
    return {}
  },
  methods: {
    triggerFileInput() {
      this.$refs.fileInput.click()
    },
    async onInputFileChange(event) {
      const inputFiles = Array.from(event?.target?.files || [])
      const isMultiple =
        this.multiple === '' ||
        this.multiple === true ||
        this.multiple === 'multiple' ||
        this.multiple === 1 ||
        this.multiple === 'true'
      const files = isMultiple ? inputFiles : inputFiles.slice(0, 1)
      if (!files.length) return

      const loading = this.$loading()
      try {
        for (const file of files) {
          const isImage = file.type.startsWith('image/')
          const isVideo = file.type.startsWith('video/')
          if (isVideo && this.videoMaxDuration) {
            const continueProcess = await this.checkVideoDuration(file)
            if (continueProcess !== true) {
              continue
            }
          }
          let maxSize = this.maxSize
          if (isVideo && this.videoMaxSize) {
            maxSize = this.videoMaxSize
          } else if (!this.maxSize && this.isXls(file)) {
            maxSize = XLSX_MAX_SIZE
          }
          if (maxSize && file.size / 1000 > maxSize) {
            let maxSizeString = `${maxSize}KB`
            if (maxSize >= 1024) {
              maxSizeString = `${(maxSize / 1024).toFixed(1)}MB`
            }
            this.$message.error(
              this.$t('UploadImageSizeStr') + ' ' + maxSizeString
            )
            continue
          }
          const res = await this.$fileApi.upload({
            file: file,
            source: this.source,
            custId: this.custId
          })
          if (res?.code === '0') {
            this.$emit('done', res, file)
            this.$emit('update:fileData', res)
            if (this.fileType === 'imageAndVideo') {
              this.$emit('fileTypeChange', isImage ? 'image' : 'video')
            }
          }
        }
      } finally {
        loading.close()
        event.target.value = ''
      }
    },
    checkVideoDuration(file) {
      return new Promise(resolve => {
        const video = document.createElement('video')
        video.preload = 'metadata'
        video.onloadedmetadata = () => {
          // 输出视频时长
          console.log(video.duration + 's')
          if (video.duration <= this.videoMaxDuration) {
            this.$emit('update:videoDuration', video.duration)
            resolve(true)
          } else {
            let minute = Math.floor(this.videoMaxDuration / 60)
            let second = this.videoMaxDuration % 60
            this.$message.error(
              `Video duration can not exceed: ${minute}m:${second}s`
            )
            resolve(false)
          }
        }
        video.onerror = () => {
          this.$message.error('Load video fail')
          resolve(false)
        }
        // 设置视频源为用户选择的文件
        video.src = URL.createObjectURL(file)
      })
    },
    async onRemove(index) {
      this.$emit('remove', index)
    },
    onDrop(event) {
      event.preventDefault()
      const files = event.dataTransfer.files
      if (files.length > 0) {
        this.onInputFileChange({ target: { files } })
      }
    },
    isXls(file) {
      return (
        file.type === 'application/vnd.ms-excel' ||
        file.type ===
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
        file.name.endsWith('.xls') ||
        file.name.endsWith('.xlsx')
      )
    }
  }
}
</script>

<style lang="scss">
.new-uploader {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  .file-drop-area {
    width: 100%;
    height: 180px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    border: 2px dashed #ccc;
    text-align: center;
    margin-bottom: 10px;
    color: #999;
    cursor: pointer;
    > i {
      font-size: 50px;
    }
    &:hover {
      background: #f5f5f5;
    }
  }
  .file-name {
    margin-top: 5px;
    color: #333;
    font-size: 14px;
    .el-button {
      margin-left: 10px;
      color: #888;
    }
  }
}
</style>
